/**CORE LIBRARIES IMPORT */
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

/**COMPONENTS / HOOKS IMPORT */
import Icon from "./Icon";
import PhotoPlaceholder from "./PhotoPlaceholder";
import SiteImage from "./SiteImage";
import useInViewOnce from "../hooks/useInViewOnce";

const MotionLink = motion.create(Link);

const occasions = [
  { icon: "birthday", label: "Birthday Parties" },
  { icon: "party", label: "Private Parties" },
  { icon: "candle", label: "Funeral Receptions" },
  { icon: "catering", label: "Catering" },
];

/** Same layout as the template's About section, mirrored. */
const PrivateEvents = () => {
  const [h2Ref, inView] = useInViewOnce(0.5);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
  };

  return (
    <section id="private-events" className="about-section private-events" aria-labelledby="private-events-heading" tabIndex={-1}>
      <div className="about-container">
        <motion.div
          className="about-right"
          initial={{ opacity: 0, x: -50 }}
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <SiteImage slot="private_events" ratio="4 / 3" className="about-image" fallback={<PhotoPlaceholder ratio="4 / 3" className="about-image" />} />
        </motion.div>

        <div className="about-left">
          <h2 id="private-events-heading" ref={h2Ref} className={`section-heading ${inView ? "in-view" : ""}`}>
            Private Events &amp; Catering
          </h2>

          <motion.p
            className="section-text"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={fadeUp}
          >
            From birthday parties to quiet gatherings and funeral receptions, tell
            us what you are planning and we will get back to you to talk through
            the details, including catering for your occasion.
          </motion.p>

          <motion.ul
            className="about-features"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.15 } } }}
          >
            {occasions.map((o) => (
              <motion.li
                className="feature"
                key={o.label}
                variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } }}
              >
                <div className="icon-wrapper">
                  <div className="icon-circle">
                    <Icon name={o.icon} size={40} />
                  </div>
                </div>
                <span>{o.label}</span>
              </motion.li>
            ))}
          </motion.ul>

          <div className="hero-buttons section-buttons">
            <MotionLink to="/book?type=private" className="hero-btn" whileHover={{ y: -6, scale: 1.05 }} whileTap={{ scale: 0.96 }}>
              Event Enquiry
            </MotionLink>
            <MotionLink to="/book?type=catering" className="hero-btn" whileHover={{ y: -6, scale: 1.05 }} whileTap={{ scale: 0.96 }}>
              Catering Enquiry
            </MotionLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivateEvents;
